import React from 'react';
import PaymentConfirmationOverview from "../../components/PaymentConfirmationOverview";
import { Trans } from '@lingui/react/macro';

function PaymentConfirmationB2B(props) {
    const locationState = props.location.state;
    
    if(!locationState) {
        return (
            <div>
                <Trans id="error_confirmation_cannot_be_seen">There was an error, confirmation page can currently not be shown.</Trans>
            </div>
        )
    }
    
    return (
        <div>
            <PaymentConfirmationOverview
                bookingNr={locationState.bookingNr}
                includePrintLink={true}
                confirmationMail={locationState.confirmationMail}
                logoutUserOnMount={locationState.logoutUserOnMount}
                bookingParts={locationState.bookingParts}
            />
        </div>
    );
}

export default PaymentConfirmationB2B;